import React, { useState } from "react";
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  Typography,
  Button,
  Grid,
  Tooltip,
  Container,
  CardContent,
} from "@material-ui/core";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import eyeFill from "@iconify/icons-eva/eye-fill";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ModifyTaskStateModal from "../../_dashboard/tareas/ModifyTaskStateModal";
import Label from "../../Label";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { makeStyles } from "@material-ui/styles";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import * as locales from "@material-ui/core/locale";
import Scrollbar from "../../Scrollbar";
import { TablaHead, TablaToolbar } from "../../_dashboard/tablas";

import MyConfirmationDialog from "../../MyConfirmationDialog";
import { empleadosApi } from "src/services/empleadosApi";
import EditarVacaciones from "./EditarVacaciones";
import { useSelector } from "react-redux";
import moment from "moment";
import { useTheme } from "@emotion/react";

const TABLE_HEAD = [
  { id: "motivo", label: "Motivo", alignRight: false },
  { id: "fechaInicio", label: "Fecha Inicio", alignRight: false },
  { id: "fechaTermino", label: "Fecha Término", alignRight: false },
  { id: "diasSolicitados", label: "Días Solicitados", alignRight: false },
  { id: "estado", label: "Estado", alignRight: false },
  { id: "" },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => {
      return (
        _user.motivo.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.fechaInicio.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.fechaTermino.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.diasSolicitados.toLowerCase().indexOf(query.toLowerCase()) !==
          -1 ||
        _user.estado.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    });
  }
  return stabilizedThis.map((el) => el[0]);
}

const styles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginTop: 20,
  },
  icon: {
    fontSize: "28px",
  },
}));

export default function TablaVacaciones(props) {
  const {
    vacaciones,
    vacacionesSolicitadas,
    vacacionesDisponibles,
    empleado,
    setShowMessagePermiso,
    setColor,
    setMessage,
    vista,
  } = props;

  const theme = useTheme();

  const [editarAdmin, setEditarAdmin] = useState(false);
  const [solicitar, setSolicitar] = useState(false);
  const [editingEmpleado, setEditingEmpleado] = useState(false);
  const [vacacion, setVacacion] = useState("");
  const [vacacionSolicitud, setVacacionSolicitud] = useState({
    fechaInicio: "",
    fechaTermino: "",
    refEmpleado: empleado.rut,
    urlArchivo: null,
    motivo: "",
    comentario: "",
    empleadoAcepta: "",
    sucursal: "",
    diasSolicitados: "",
  });

  const [mostrarEstado, setMostrarEstado] = useState(false);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
  const [showRemovalConfirmation, setShowRemovalConfirmation] = useState(false);
  const [visualizaEmpleado, setVisualizaEmpleado] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const { empleado: user } = useSelector((state) => state.auth.user);
  const [updateSolicitudVacaciones] =
    empleadosApi.useUpdateSolicitudVacacionesMutation();
  const [deleteVacacionEmpleado] =
    empleadosApi.useDeleteVacacionEmpleadoMutation();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("nombre");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [locale] = useState("esES");
  const classes = styles();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = vacaciones?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - vacaciones?.length) : 0;

  const filteredUsers = applySortFilter(
    vacaciones,
    getComparator(order, orderBy),
    filterName,
  );

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const isUserNotFound = filteredUsers.length === 0;

  const editarVacacion = (row) => {
    //cambiar por user.rol === "ADMIN" || user.rol === "SUPER_ADMIN"
    if (vista !== "EMPLEADO") {
      setEditarAdmin(true);
      setVacacion(row);
    } else {
      if (row.estado === "PENDIENTE") {
        setSolicitar(true);
        setEditingEmpleado(true);
        setVisualizaEmpleado(false);
        setVacacionSolicitud(row);
      } else {
        setSolicitar(true);
        setEditingEmpleado(true);
        setVisualizaEmpleado(true);
        setVacacionSolicitud(row);
      }
    }
  };

  const cambiarEstado = async (nuevoEstado) => {
    if (nuevoEstado !== "PENDIENTE") {
      const holiday = {
        estado: nuevoEstado,
        id: estadoSeleccionado.id,
        comentario: estadoSeleccionado.comentario,
        refEmpleadoSolicita: estadoSeleccionado.refEmpleado,
        refEmpleadoAcepta: user.nombre + " " + user.apellidos,
      };
      try {
        await updateSolicitudVacaciones(holiday).unwrap();
        setEstadoSeleccionado(null);
        setShowMessagePermiso(true);
        setColor("success");
        setMessage("Solicitud de Vacaciones Actualizada Correctamente");
      } catch {
        setShowMessagePermiso(true);
        setColor("error");
        setMessage(
          "Ocurrió un error en el servidor. Inténtelo nuevamente más tarde.",
        );
      }
    } else {
      setEstadoSeleccionado(null);
    }
  };

  const handleChangeState = (row) => {
    if (row.estado === "PENDIENTE" && vista !== "EMPLEADO") {
      setEstadoSeleccionado(row);
      setMostrarEstado(true);
    }
  };

  const handleDeleteVacacion = (id) => {
    setShowRemovalConfirmation(true);
    setSelectedId(id);
  };

  const eliminarVacacion = async () => {
    try {
      await deleteVacacionEmpleado(selectedId).unwrap();
      setShowRemovalConfirmation(false);
      setShowMessagePermiso(true);
      setColor("success");
      setMessage("Solicitud de Vacaciones Eliminada Correctamente");
    } catch {
      setShowRemovalConfirmation(false);
      setShowMessagePermiso(true);
      setColor("error");
      setMessage(
        "Ocurrió un error en el servidor. Inténtelo nuevamente más tarde.",
      );
    }
  };

  const solicitarVacacion = () => {
    if (
      vacaciones.filter((vacacion) => vacacion.estado === "PENDIENTE").length >
      0
    ) {
      setShowMessagePermiso(true);
      setColor("info");
      setMessage("Aún Tienes Una Solicitud Pendiente");
    } else {
      if (vacacionesDisponibles > 0) {
        setVacacionSolicitud({
          fechaInicio: "",
          fechaTermino: "",
          refEmpleado: empleado.rut,
          urlArchivo: null,
          motivo: "",
          comentario: "",
          empleadoAcepta: "",
          sucursal: "",
          diasSolicitados: "",
        });
        setSolicitar(true);
        setEditingEmpleado(false);
      } else {
        setShowMessagePermiso(true);
        setColor("info");
        setMessage("No Tienes Días Disponibles Para Solicitar Vacaciones.");
      }
    }
  };

  return (
    <div>
      <Card>
        <Typography variant="h5" component="h2" className={classes.title}>
          {vista === "EMPLEADO"
            ? "Solicitud de Vacaciones"
            : "Vacaciones del Empleado"}
        </Typography>
        <Grid
          container
          style={{ padding: "1rem 1.5rem 0rem 1.5rem" }}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs md>
            <TablaToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
            />
          </Grid>

          {vista === "EMPLEADO" && (
            <Grid item xs md>
              <Grid container direction="row-reverse">
                <Grid item xs={12} md={6}>
                  <Container style={{ marginLeft: ".5rem" }}>
                    <Button
                      variant="contained"
                      onClick={() => solicitarVacacion()}
                      startIcon={<Icon icon={plusFill} />}
                      style={{ minWidth: "170px" }}
                    >
                      Solicitar Vacaciones
                    </Button>
                  </Container>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid container>
          <Grid item xs={5} md={5}>
            <Card
              color="primary"
              style={{
                backgroundColor: theme.palette.primary.main,
                marginLeft: 10,
              }}
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14, fontWeight: "bold" }}
                  color="white"
                  gutterBottom
                >
                  {vacacionesSolicitadas < 1
                    ? `No ha solicitado vacaciones`
                    : vacacionesSolicitadas === 1
                      ? `${vacacionesSolicitadas} Día solicitado y aceptado`
                      : `${vacacionesSolicitadas} Días solicitados y aceptados`}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={2} md={2}></Grid>
          <Grid item xs={5} md={5}>
            <Card
              color="primary"
              style={{
                backgroundColor: theme.palette.primary.main,
                marginRight: 10,
              }}
            >
              <CardContent>
                <Typography
                  sx={{ fontSize: 14, fontWeight: "bold" }}
                  color="white"
                  gutterBottom
                >
                  {vacacionesDisponibles <= 1
                    ? `No posees vacaciones disponibles`
                    : `${vacacionesDisponibles} Días disponibles`}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <TablaHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={vacaciones?.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    const {
                      fechaInicio,
                      fechaTermino,
                      motivo,
                      diasSolicitados,
                      estado,
                    } = row;
                    const isItemSelected = selected.indexOf(motivo) !== -1;

                    return (
                      <TableRow
                        hover
                        key={
                          fechaInicio + fechaTermino + motivo + diasSolicitados
                        }
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell
                          align="center"
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Typography variant="subtitle2" noWrap>
                            {motivo}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          {moment(fechaInicio, "YYYY/MM/DD").format(
                            "DD/MM/YYYY",
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {moment(fechaTermino, "YYYY/MM/DD").format(
                            "DD/MM/YYYY",
                          )}
                        </TableCell>
                        <TableCell align="left">{diasSolicitados}</TableCell>
                        <TableCell align="left">
                          <Label
                            onClick={() => handleChangeState(row)}
                            style={{
                              cursor:
                                vista !== "EMPLEADO" &&
                                row.estado === "PENDIENTE"
                                  ? "pointer"
                                  : false,
                            }}
                            variant="ghost"
                            color={
                              (estado === "RECHAZADO" && "error") ||
                              (estado === "PENDIENTE" && "warning") ||
                              (estado === "ACEPTADO" && "success") ||
                              "info"
                            }
                          >
                            {sentenceCase(estado)}
                          </Label>
                        </TableCell>
                        <TableCell align="center">
                          {estado === "PENDIENTE" ? (
                            <Tooltip title="Editar">
                              <Button
                                color="primary"
                                onClick={() => {
                                  editarVacacion(row);
                                }}
                              >
                                <EditIcon />
                              </Button>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Visualizar">
                              <Button
                                color="primary"
                                onClick={() => {
                                  editarVacacion(row);
                                }}
                              >
                                <Icon icon={eyeFill} className={classes.icon} />
                              </Button>
                            </Tooltip>
                          )}

                          {vista === "EMPLEADO" && estado === "PENDIENTE" && (
                            <Tooltip title="Eliminar">
                              <Button
                                color="error"
                                onClick={() => handleDeleteVacacion(row.id)}
                              >
                                <DeleteIcon />
                              </Button>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      No se han agregado elementos
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <ThemeProvider
          theme={(outerTheme) => createTheme(outerTheme, locales[locale])}
        >
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={vacaciones?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Card>

      {editarAdmin && (
        <EditarVacaciones
          open={editarAdmin}
          setOpen={setEditarAdmin}
          editingAdmin={true}
          editingEmpleado={false}
          setEditingEmpleado={setEditingEmpleado}
          vacacion={vacacion}
          setVacacion={setVacacion}
          empleado={empleado}
          titulo={"Solicitud de Vacaciones del Empleado"}
          setShowMessagePermiso={setShowMessagePermiso}
          setColor={setColor}
          setMessage={setMessage}
          visualizaEmpleado={false}
          setVisualizaEmpleado={setVisualizaEmpleado}
          vacacionesDisponibles={vacacionesDisponibles}
        />
      )}

      {solicitar && (
        <EditarVacaciones
          open={solicitar}
          setOpen={setSolicitar}
          editingAdmin={false}
          editingEmpleado={editingEmpleado}
          setEditingEmpleado={setEditingEmpleado}
          vacacion={vacacionSolicitud}
          setVacacion={setVacacionSolicitud}
          empleado={empleado}
          titulo={"Solicitud de Vacaciones"}
          setShowMessagePermiso={setShowMessagePermiso}
          setColor={setColor}
          setMessage={setMessage}
          visualizaEmpleado={visualizaEmpleado}
          setVisualizaEmpleado={setVisualizaEmpleado}
          vacacionesDisponibles={vacacionesDisponibles}
        />
      )}

      {estadoSeleccionado !== null && (
        <ModifyTaskStateModal
          task={estadoSeleccionado}
          onSubmit={cambiarEstado}
          onClose={() => setMostrarEstado(false)}
          states={["RECHAZADO", "PENDIENTE", "ACEPTADO"]}
          open={mostrarEstado}
          cargandoDatos={false}
        />
      )}

      <MyConfirmationDialog
        open={showRemovalConfirmation}
        onSubmit={() => eliminarVacacion()}
        onClose={() => setShowRemovalConfirmation(false)}
        title="Eliminar Solicitud de Vacación"
        content="¿Está seguro de eliminar esta solicitud?"
      />
    </div>
  );
}
